module.exports = __webpack_public_path__ + "img/recombinant-modal-info.4fb9270.png";